export default __webpack_public_path__ + "static/media/guardianhead.28798808.png";